/*eslint-disable*/
import api from '../'

class transcriptionInWordGameItems {
    // POST: couples
    static getItemsByRequest (params) {
        return api.axios.get('/transcriptionInWord/items', { params }).then(response => response.data.items);
    }
}

export default transcriptionInWordGameItems;
